import { render, staticRenderFns } from "./DateGroup.vue?vue&type=template&id=1b06f2af&"
import script from "./DateGroup.vue?vue&type=script&lang=js&"
export * from "./DateGroup.vue?vue&type=script&lang=js&"
import style0 from "./DateGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports